import Api from '@api/coupon'
import { CHAT_PATH } from '@hlj/hlj-constant'
import { isUltimate } from '@merchant-backend/util'
import BaseStore from '@store/table'
import { notUltimateAlert } from '@util'

class Store extends BaseStore {
  id = null
  $listApi = Api.getReceiveList

  $getParams = () => {
    return { coupon_id: this.id }
  }

  $extraOp = data => {
    this.$list = this.$list.map((item, index) => {
      return {
        ...item,
        row_id: index + 1 // 小程序过来的优惠券没有 id，所以统一用 index 作为 rowKey
      }
    })
  }

  contact = (id, user) => async () => {
    if (isUltimate()) {
      const newWindow = window.open('', '_blank')

      const { success } = await Api.contactApi({ id, is_viewed: 1 })
      if (success) {
        this.$getList()

        newWindow.location.href = `${CHAT_PATH}?to_user_id=${user.id}`
      }
    } else {
      notUltimateAlert()
    }
  }
}

export default Store
